export const ARCHIVE_STAGE_INITIAL = 'initial';
export const ARCHIVE_STAGE_CONFIRMING = 'confirming';
